export function buildHeader(tab) {
    const header = tab === 'current-reimbursement-tab' ? [
        'Prorata Share',
        'Lease Type',
        'Reimb Code',
        'Annual Taxes',
        'PSF',
        'Annual Insurance',
        'PSF',
        'Annual CAM',
        'PSF',
        'Annual Mgmt. Fee',
        'PSF',
        'Annual Other',
        'PSF',
        'Annual Total',
        'PSF',
        'Notes',
        null,
        'Annual RET',
        'PSF',
        'Annual INS',
        'PSF',
        'Annual CAM',
        'PSF',
        'Annual Other',
        'PSF',
        'Collecting Annual Total',
        'PSF',
        null,
        'Monthly RET',
        'PSF',
        'Monthly INS',
        'PSF',
        'Monthly CAM',
        'PSF',
        'Monthly Other',
        'PSF',
        'Monthly Total',
        'PSF',
    ] : [
        'Prorata Share',
        'Lease Type',
        'Reimb Code',
        'Annual Taxes',
        'PSF',
        'Annual Insurance',
        'PSF',
        'Annual CAM',
        'PSF',
        'Annual Mgmt. Fee',
        'PSF',
        'Annual Other',
        'PSF',
        'Annual Total',
        'PSF',
        'Notes',
    ];
    return {
        headerRow: header,
        rows: {'no-row': {valueCells: []}}
    }
}